<template>
  <div class="">

  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components:{},
  computed:{},
  methods:{},
  mounted:function(){}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    @zrGreen:#02cd8c;

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue